import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwartaxi() {



    const cardData = {

keyword: "Pune to Mahabaleshwar Taxi",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Mahabaleshwar Taxi services for families, couples, tourists, and weekend travelers. We provide Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles for one-way and round-trip journeys with experienced chauffeurs. Our service includes doorstep pickup, 24/7 booking support, transparent pricing, and well-maintained cabs, ensuring a smooth and enjoyable journey from Pune to the scenic hill station of Mahabaleshwar.",

topPlaces: [
    {
        title: "Arthur's Seat",
        description:
            "Arthur's Seat is one of the most famous viewpoints in Mahabaleshwar, offering stunning panoramic views of deep valleys, rivers, and the surrounding Sahyadri mountain ranges. It is often called the 'Queen of all viewpoints' due to its breathtaking scenery. Visitors enjoy the dramatic cliffs, cool breeze, and mesmerizing landscapes, especially during sunrise and sunset."
    },
    {
        title: "Venna Lake",
        description:
            "Venna Lake is a popular man-made lake surrounded by lush greenery and hills. It is ideal for boating, horse riding, and family picnics. The lakeside is lined with food stalls and small shops, making it a lively yet peaceful attraction for tourists throughout the year."
    },
    {
        title: "Wilson Point",
        description:
            "Wilson Point is the highest point in Mahabaleshwar and is famous for its spectacular sunrise views. Visitors gather early in the morning to witness the sun rising over the mist-covered hills. The location offers a serene atmosphere and wide panoramic views of the entire hill station."
    },
    {
        title: "Pratapgad Fort",
        description:
            "Pratapgad Fort is a historic Maratha fort built by Chhatrapati Shivaji Maharaj and is known for its strategic importance in the Battle of Pratapgad. The fort features strong stone structures, ancient pathways, and scenic surroundings, making it a must-visit for history lovers and trekkers."
    },
    {
        title: "Lingmala Waterfall",
        description:
            "Lingmala Waterfall is a beautiful natural attraction that becomes especially spectacular during the monsoon season. The cascading water flows through dense greenery, creating a refreshing and scenic environment perfect for photography and nature walks."
    },
    {
        title: "Mapro Garden",
        description:
            "Mapro Garden is a famous tourist attraction known for its strawberry farms, fresh fruit products, chocolate factory, and delicious food items. Visitors can enjoy strawberry-based desserts, garden walks, and shopping for local products."
    },
    {
        title: "Elephant's Head Point",
        description:
            "Elephant's Head Point is a unique viewpoint named after its rock formation resembling an elephant’s head and trunk. It offers breathtaking views of valleys, cliffs, and surrounding mountain ranges, making it a favorite spot for photography."
    },
    {
        title: "Panchgani Table Land (Nearby)",
        description:
            "Table Land in Panchgani, located near Mahabaleshwar, is one of Asia's largest volcanic plateaus. It offers vast open landscapes, horse rides, and stunning views of surrounding hills and valleys."
    },
    {
        title: "Kate's Point",
        description:
            "Kate's Point is a scenic viewpoint overlooking the Krishna Valley and Dhom Dam. It is famous for its calm atmosphere and picturesque landscapes, making it a popular stop for tourists exploring Mahabaleshwar."
    },
    {
        title: "Chinaman's Falls",
        description:
            "Chinaman's Falls is a beautiful waterfall surrounded by dense forests and hills. It offers a peaceful natural setting and is best visited during the monsoon when the waterfall is in full flow."
    }
],



services: [
{
name: "Pune to Mahabaleshwar Cab",
description: "Rising Cab Service offers Pune to Mahabaleshwar Cab with safe, comfortable, and affordable travel for families, couples, and tourists. Choose from AC Sedan, SUV, Innova Crysta, Ertiga, and Tempo Traveller for one way, round trip, and weekend holiday trips to the scenic hill station of Mahabaleshwar."
},
{
name: "Pune to Mahabaleshwar Taxi",
description: "Book Pune to Mahabaleshwar Taxi with Rising Cab Service for reliable and stress-free hill station travel. We provide professional drivers, clean vehicles, and 24x7 booking support for comfortable journeys at affordable fares."
},
{
name: "Cab from Pune to Mahabaleshwar",
description: "Our Cab from Pune to Mahabaleshwar service ensures smooth highway travel with doorstep pickup and drop. Enjoy safe rides in well-maintained vehicles suitable for solo travelers, families, and group tours."
},
{
name: "Taxi from Pune to Mahabaleshwar",
description: "Rising Cab Service provides Taxi from Pune to Mahabaleshwar with experienced chauffeurs, transparent pricing, and flexible travel options for one way and round trip journeys."
},
{
name: "Pune to Mahabaleshwar Cab Service",
description: "Our Pune to Mahabaleshwar Cab Service offers comfortable, reliable, and budget-friendly travel with multiple cab options including Sedan, SUV, Ertiga, and luxury Innova Crysta."
},
{
name: "Pune to Mahabaleshwar Taxi Fare",
description: "Get affordable Pune to Mahabaleshwar Taxi Fare with transparent pricing and no hidden charges. We offer economical packages for family trips, weekend getaways, and sightseeing tours."
},
{
name: "Pune to Mahabaleshwar One Way Cab",
description: "Book Pune to Mahabaleshwar One Way Cab for convenient and budget-friendly travel with flexible pickup and drop services and comfortable AC vehicles."
},
{
name: "Pune to Mahabaleshwar Round Trip Taxi",
description: "Our Pune to Mahabaleshwar Round Trip Taxi service is perfect for weekend trips and sightseeing tours with return journey convenience and flexible waiting options."
},
{
name: "Pune to Mahabaleshwar Cab Booking",
description: "Rising Cab Service offers Pune to Mahabaleshwar Cab Booking with instant confirmation, multiple vehicle choices, and 24x7 support for hassle-free travel planning."
},
{
name: "Cheap Pune to Mahabaleshwar Cab",
description: "Choose Cheap Pune to Mahabaleshwar Cab for affordable travel without compromising comfort and safety, ideal for families, students, and group travelers."
},
{
name: "Best Pune to Mahabaleshwar Cab",
description: "Rising Cab Service provides the Best Pune to Mahabaleshwar Cab with premium vehicles, experienced drivers, punctual service, and smooth travel experience."
},
{
name: "24x7 Pune to Mahabaleshwar Cab Service",
description: "Our 24x7 Pune to Mahabaleshwar Cab Service ensures round-the-clock availability, instant booking, and reliable transportation anytime you need."
},
{
name: "Outstation Cab Pune to Mahabaleshwar",
description: "Rising Cab Service offers Outstation Cab Pune to Mahabaleshwar for safe long-distance travel with AC vehicles, professional drivers, and flexible pickup options."
},
{
name: "Pune to Tapola Cab",
description: "Book Pune to Tapola Cab with Rising Cab Service for scenic lake-side travel near Mahabaleshwar with comfortable vehicles and affordable pricing."
},
{
name: "Pune to Tapola Cab Service",
description: "Our Pune to Tapola Cab Service provides safe and convenient transportation to Tapola with experienced drivers and well-maintained AC vehicles for a relaxing trip."
}
],

tableData: [
["Pune to Mahabaleshwar Cab","Pune to Mahabaleshwar Taxi"],
["Cab from Pune to Mahabaleshwar","Taxi from Pune to Mahabaleshwar"],
["Pune to Mahabaleshwar Cab Service","Pune to Mahabaleshwar Taxi Fare"],
["Pune to Mahabaleshwar One Way Cab","Pune to Mahabaleshwar Round Trip Taxi"],
["Pune to Mahabaleshwar Cab Booking","Cheap Pune to Mahabaleshwar Cab"],
["Best Pune to Mahabaleshwar Cab","24x7 Pune to Mahabaleshwar Cab Service"],
["Outstation Cab Pune to Mahabaleshwar","Pune to Tapola Cab"],
["Pune to Tapola Cab Service","Hill Station Cab Pune Mahabaleshwar"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Mahabaleshwar Taxi Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Mahabaleshwar taxi transportation for families, couples, tourists, corporate travelers, and weekend vacation enthusiasts."
    },
    {
        WhyChooseheading: "Perfect for Hill Station Holidays",
        WhyChoosedescription: "Mahabaleshwar is one of Maharashtra's most popular hill stations, known for its scenic valleys, viewpoints, strawberry farms, and pleasant climate throughout the year."
    },
    {
        WhyChooseheading: "Flexible Travel Plans for Every Traveler",
        WhyChoosedescription: "Customers can choose one-way taxi services, same-day return trips, weekend packages, overnight stays, and customized sightseeing itineraries."
    },
    {
        WhyChooseheading: "Premium Vehicles for a Relaxing Journey",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to your group size and travel preferences."
    },
    {
        WhyChooseheading: "Cover Major Tourist Attractions Easily",
        WhyChoosedescription: "Travel conveniently to Venna Lake, Arthur Seat Point, Elephant's Head Point, Mapro Garden, Wilson Point, Lingmala Waterfall, and other famous attractions."
    },
    {
        WhyChooseheading: "Doorstep Pickup from Pune and PCMC",
        WhyChoosedescription: "Pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding Pune locations."
    },
    {
        WhyChooseheading: "Safe Travel Through Ghat Roads",
        WhyChoosedescription: "Our experienced drivers are familiar with the Mahabaleshwar route and ensure a smooth, safe, and enjoyable travel experience."
    },
    {
        WhyChooseheading: "Ideal for Families, Couples, and Groups",
        WhyChoosedescription: "Whether planning a romantic getaway, family vacation, group tour, or corporate outing, Rising Cab Service offers suitable travel solutions."
    }
]
};

const faqData = [
    {
        question: "Why is Mahabaleshwar a popular destination from Pune?",
        answer: "Mahabaleshwar is famous for its cool climate, scenic viewpoints, strawberry farms, waterfalls, lakes, and natural beauty."
    },
    {
        question: "Can I book a one-way taxi from Pune to Mahabaleshwar?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which tourist attractions can be covered during the trip?",
        answer: "Popular attractions include Venna Lake, Arthur Seat Point, Elephant's Head Point, Mapro Garden, Wilson Point, Lingmala Waterfall, and Pratapgad Fort."
    },
    {
        question: "Which vehicle is suitable for a family trip to Mahabaleshwar?",
        answer: "Ertiga and Innova Crysta are among the most preferred vehicles because of their spacious seating and travel comfort."
    },
    {
        question: "Do you provide Tempo Travellers for group outings?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and tourist groups."
    },
    {
        question: "Can same-day return trips be arranged?",
        answer: "Yes, same-day return taxi packages can be organized depending on the customer's schedule."
    },
    {
        question: "Is Mahabaleshwar suitable for honeymoon and couple trips?",
        answer: "Yes, Mahabaleshwar is one of the most preferred destinations for couples due to its romantic weather and beautiful viewpoints."
    },
    {
        question: "Can Panchgani be included in the travel itinerary?",
        answer: "Yes, customers can combine Mahabaleshwar and Panchgani sightseeing in a customized travel package."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I reserve a Pune to Mahabaleshwar Taxi?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sanket Jagtap",
        feedback:
            "Our Mahabaleshwar weekend getaway was perfectly organized. The vehicle was clean, the journey was comfortable, and we enjoyed every sightseeing location without worrying about transportation.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pooja Deshpande",
        feedback:
            "The trip to Mahabaleshwar with our family was truly memorable. The driver was professional, the cab was spacious, and the overall travel experience was excellent from start to finish.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Mahabaleshwar Taxi Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-mahabaleshwar-cab.jpg",
"description": "Book Pune to Mahabaleshwar Taxi Service with Rising Cab Service for safe, comfortable, and scenic hill station travel. Enjoy reliable one-way and round-trip cab service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-mahabaleshwar-cab"
}
};






    return (
        <div>

<Helmet>
  <title>Pune to Mahabaleshwar Taxi Service | Hill Station Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Mahabaleshwar Taxi Service for safe and comfortable hill station travel. Get affordable one-way and round-trip cab service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to mahabaleshwar cab, pune to mahabaleshwar taxi, cab from pune to mahabaleshwar, taxi from pune to mahabaleshwar, pune to mahabaleshwar cab service, pune to mahabaleshwar taxi fare, pune to mahabaleshwar one way cab, pune to mahabaleshwar round trip taxi, pune to mahabaleshwar cab booking"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwartaxi;